<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left">
        <label
          for="businessName"
          class="mb-1 input-label bold-text"
          style="text-transform: capitalize"
          >Business/{{ type }} Name<span class="required">*</span></label
        >
        <a-input
          :size="'large'"
          placeholder="Enter Name"
          v-model.lazy="$v.bName.$model"
        />
        <div class="error-container" v-if="$v.bName.$error">
          <div class="error-item" v-if="!$v.bName.required">
            Name is required
          </div>  
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left">
        <label for="email" class="mb-1 input-label bold-text"
          >{{ type === "provider" ? "Physican Email" : "Email" }} Address<span
            class="required"
            >*</span
          ></label
        > 
        <a-input
          :size="'large'"
          type="email"
          placeholder="Enter Email"
          v-model.lazy="$v.bEmail.$model"
        />
        <div class="error-container" v-if="$v.bEmail.$error">
          <div class="error-item" v-if="!$v.bEmail.required">
            Email is required 
          </div>
          <div class="error-item" v-if="!$v.bEmail.email">
            Enter correct email format
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left">
        <label for="phone" class="mb-1 input-label bold-text"
          >Phone Number<span class="required">*</span></label
        >
        <a-input
          :size="'large'"
          :maxLength="14"
          type="tel"
          placeholder="Enter Phone Number"
          v-model.lazy="$v.bPhone.$model"
        />
        <div class="error-container" v-if="$v.bPhone.$error">
          <div class="error-item" v-if="!$v.bPhone.required">
            Phone Number is required
          </div>
          <div class="error-item" v-if="!$v.bPhone.minLength">
            length should be 10
          </div>
        </div>
      </div>

      <div
        v-if="type === 'provider' || type === 'hcp'"
        class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left"
      >
        <label for="npiNumber" class="mb-1 input-label bold-text"
          >NPI Number<span class="required">*</span></label
        >
        <a-input
          :size="'large'"
          :maxLength="10"
          placeholder="Enter NPI number"
          v-model.lazy="$v.npiNumber.$model"
        />
        <div class="error-container" v-if="$v.npiNumber.$error">
          <div class="error-item" v-if="!$v.npiNumber.required">
            NPI Number is required
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 pb-3 text-left">
        <label for="street" class="mb-1 input-label bold-text"
          >Street Address<span class="required">*</span></label
        >
        <a-input
          :size="'large'"
          placeholder="Enter address"
          v-model.lazy="$v.street.$model"
        />
        <div class="error-container" v-if="$v.street.$error">
          <div class="error-item" v-if="!$v.street.required">
            Address is required
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left">
        <label for="city" class="mb-1 input-label bold-text"
          >City<span class="required">*</span></label
        >
        <!-- <a-input :size="'large'" placeholder="" v-model.lazy="$v.city.$model" /> -->

        <a-select
          show-search
          :size="'large'"
          class="w-100"
          placeholder="Search City"
          style="width: 120px"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :defaultValue="city"
          @search="val => getLocations(val)"
          @select="val => selectLocation(val)"
        >
          <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)"
            >{{ c.city }}, {{ c.state }}
          </a-select-option>
        </a-select>

        <div class="error-container" v-if="$v.city.$error">
          <div class="error-item" v-if="!$v.city.required">
            City is required
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-left">
        <label for="postalCode" class="mb-1 input-label bold-text"
          >Zip/Postal Code<span class="required">*</span></label
        >
        <!-- <a-input
          :size="'large'"
          placeholder=""
          v-model.lazy="$v.postalCode.$model"
        /> -->
        <a-select
          class="w-100"
          :min="0"
          :size="'large'"
          placeholder="Zipcode"
          v-model="$v.postalCode.$model"
          :disabled="city ? false : true"
        >
          <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode">
            {{ zipcode }}
          </a-select-option>
        </a-select>
        <div class="error-container" v-if="$v.postalCode.$error">
          <div class="error-item" v-if="!$v.postalCode.required">
            Zip/Postal code is required
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-12 text-right"></div>
      <div class="col-md-6 col-lg-6 col-sm-12 pb-3 text-center">
        <a-button
          :loading="loading"
          @click="addProvider"
          class="dovemed-button font-white ml-4 primary-button"
          :style="{
            background: getPrimaryColor(),
            border: '1px solid' + getPrimaryColor()
          }"
        >
          SUBMIT
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
const AppRepository = RepositoryFactory.get("app");
const UserRepository = RepositoryFactory.get("user");

export default {
  name: "AddProvider",

  data() {
    return {
      bName: undefined,
      bEmail: undefined,
      bPhone: undefined,
      npiNumber: undefined,
      street: undefined,
      city: undefined,
      postalCode: undefined,
      loading: false,
      locationsList: [],
      zipCodeArray: [],
      phoneNum: undefined
    };
  },

  validations: {
    bName: {
      required
    },
    bEmail: {
      required,
      email
    },
    bPhone: {
      required,
      minLength: minLength(14),
      maxLength: maxLength(14)
    },
    npiNumber: {
      required: requiredIf(function() {
        return this.type === "provider";
      }) 
    },
    street: {
      required
    },
    city: {
      required
    },
    postalCode: {
      required
    }
  },

  props: {
    type: String
  },

  watch: {
    bPhone: function(val) {
      let output = "(";
      this.bPhone.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function(
        match,
        g1,
        g2,
        g3
      ) {
        if (g1.length) {
          output += g1;
          if (g1.length == 3) {
            output += ")";
            if (g2.length) {
              output += " " + g2;
              if (g2.length == 3) {
                output += "-";
                if (g3.length) {
                  output += g3;
                }
              }
            }
          }
        }
      });
      this.bPhone = output;
    }
  },

  methods: {
    getLocations(city) {
      AppRepository.getLocations(city)
        .then(res => {
          this.locationsList = res.data.data && res.data.data.data;
        })
        .catch(err => null);
    },

    selectLocation(val) {
      const value = JSON.parse(val);
      this.city = value.city;

      this.zipCodeArray = [...value.city_zipcodes];
    },
    addProvider() {
      this.empty = !this.$v.$anyDirty;
      this.errors = this.$v.$anyError;

      if (this.$v.$anyError === false && this.empty === false) {
        this.loading = true;
        const data = {
          name: this.bName,
          email: this.bEmail,
          phone: this.bPhone,
          npi_number: this.npiNumber,
          type: this.type,
          location: {
            address_line1: this.street,
            address_line2: "",
            city: this.city,
            state: "",
            country: "",
            zip_code: this.postalCode
          }
        };
        console.log(data);

        UserRepository.addProvider(data)
          .then(res => {
            this.loading = false;
            this.bName = null;
            this.bEmail = null;
            this.bPhone = null;
            this.npiNumber = null;
            this.street = null;
            this.city = null;
            this.postalCode = null;
            this.$v.$reset();
            this.notify(
              "success",
              "Success",
              this.type + " added successfully."
            );
          }) 
          .catch(err => {
            this.loading = false; 
            if (
              err.response.data.message.includes(
                "this npi number already exists"
              )  
            ) {
              this.notify("error", "Error", "NPI number has to be unique");
            } else {
              this.notify("error", "Error", "Something went wrong !");
            }
          });
      } else {
        this.$v.$touch();
        this.loading = false;
      }
    }
  }
}; 
</script>

<style>
.required {
  color: tomato !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/provider/AddProvider.vue